import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { track } from "../utils/analytics";

const easeSoft = [0.4, 0, 0.2, 1];

export function useStickerLille() {
  return React.useMemo(() => {
    if (typeof window === "undefined") return false;
    const src = new URLSearchParams(window.location.search).get("utm_source");
    return !!src && src.toLowerCase() === "sticker_lille";
  }, []);
}

export default function StickerModal({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    track("sticker_lille_landing", { source: "sticker_lille" });
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="sticker-lille-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.1, ease: easeSoft }}
          className="fixed inset-0 z-[100] flex items-center justify-center px-6"
          style={{ backgroundColor: "rgba(7, 7, 8, 0.92)" }}
        >
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.9, delay: 0.25, ease: easeSoft }}
            className="max-w-2xl text-center"
          >
            <span className="block h-px w-12 bg-leaf mx-auto mb-10" />
            <p translate="no" className="notranslate text-[10px] tracking-[0.45em] uppercase text-bone/50 mb-8">
              Fight-Lens
            </p>
            <h2
              data-testid="sticker-lille-text"
              className="font-serif font-light text-bone leading-snug tracking-tight text-2xl sm:text-3xl md:text-4xl"
            >
              Tu n&apos;as pas écouté…
              <span className="block mt-4 italic text-bone/90">
                Bienvenue dans la galerie Fight-Lens.
              </span>
            </h2>
            <p className="mt-8 text-ash text-sm md:text-base leading-relaxed max-w-md mx-auto">
              Prends le temps d&apos;observer chaque détail.
            </p>
            <motion.button
              data-testid="sticker-lille-enter-btn"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 1, ease: easeSoft }}
              onClick={() => {
                track("sticker_lille_enter_gallery");
                onClose();
              }}
              className="group mt-12 inline-flex items-center gap-3 border border-bone/30 hover:border-leaf hover:bg-leaf/10 transition-all duration-500 px-8 py-4"
            >
              <span className="text-[11px] tracking-[0.32em] uppercase text-bone">
                Entrer dans la galerie
              </span>
            </motion.button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
